module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAABCUlEQVQ4y62UwXHDIBBFnzS6RyVQgtMBHYQSoAOXYHegDpYS1EFIBy5BJSgVkMsyQxJkm0z+kYXH8neXIefMMwrBnwB3EE4jz8sBvrFuATvRp00kXn5kegHoBRGCN4CplgywdYOACMzAXns0FLND8LP6YA4Atn4ikIBVJO4AQ865VCTpLavC3oBPYGmAduCkmVmReBs1k0I3IvEsEh3wWk6pwakCLSLR6KUpBD+PWtJNJH4rrUi8aex8ZJae2QA/anrrwcYVeHlg/grMI/+kHlApgtHn/A2knjnAicRfoK6GVFhTU8do2NbsdYG0Yd8boY/SXwVkyxTf+UKud0YnTdUIHOn6IJ6A5QveNF4B7R72zQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Mail box.png
// module id = 183
// module chunks = 0 1